/** Laat de browser een tekstbestand opslaan (back-up, CSV, agenda). Geeft false als het niet lukte. */
export function downloadBestand(naam: string, inhoud: string, mime: string, bom = false): boolean {
  try {
    const url = URL.createObjectURL(new Blob([bom ? '﻿' : '', inhoud], { type: `${mime};charset=utf-8` }));
    const a = document.createElement('a');
    a.href = url;
    a.download = naam;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 10_000);
    return true;
  } catch {
    return false;
  }
}
